import { Grid, Typography } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import { convertNumbers } from "../../utils/ConvertNumbers";
import { useHistory } from "react-router";

const ReportCard = (props) => {
  const history = useHistory();
  const goToDetails = () => {
    history.push(props.link);
  };

  return (
    <Grid
      style={{ paddingRight: "8px", paddingLeft: "8px" }}
      item
      sx={12}
      sm={6}
      md={4}
      lg={3}
    >
      <Card style={{ marginBottom: "8px" }}>
        <CardMedia
          component="img"
          height="140"
          image={props.image}
          alt="project-media"
        />
        <CardContent>
          <Typography align="center" style={{ fontWeight: "bold" }}>
            {convertNumbers(props.title)}
          </Typography>
          <div
            style={{
              height: "16px",
              borderBottom: "1px solid #e6e9ed",
              marginBottom: "16px",
            }}
          ></div>
          <Grid
            style={{
              fontSize: "14px",
              color: "#73879c",
              paddingTop: "16px",
            }}
            container
            direction="row"
            alignItems="center"
          >
            <Grid item sx={12} sm={12} md={12} lg={12}>
              <Button
                onClick={goToDetails}
                style={{
                  width: "100%",
                  color: "#1976d2",
                }}
                variant="outlined"
                endIcon={<InfoIcon />}
              >
                جزئیات بیشتر
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default ReportCard;
